import React from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../../template/_metronic/helpers'

type Props = {
  totalErrors?: string
}

export default function ErrorDetailHeader({totalErrors}: Props) {
  const navigate = useNavigate()
  return (
    <div className='card-header border-0 pt-5'>
      <h3 className='card-title align-items-start flex-column'>
        <span className='card-label fw-semibold text-primary-dark fs-1 mb-1 '>
          Usuarios con error
        </span>
        <span className='text-muted mt-1 fs-2'>
          Encontrados: {totalErrors || '0'}
        </span>
      </h3>
      <div className='card-toolbar'>
        <button
          type='button'
          className='btn btn-light-primary-dark me-3'
          onClick={() => navigate('/upload-file/new')}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-4 me-1' />
          Regresar
        </button>
      </div>
    </div>
  )
}
